<template>
	<!-- 批量审核结果弹窗 -->
	<el-dialog title="操作结果" :visible.sync="resultDialogVisble" width="400px" show-close>
		<div class="result-content">
			<!-- 部分导入失败 -->
			<div class="flex-column gap-16 font-h4-regular yx-color-text-primary">
				<p>
					本次共操作
					<span class="font-h4-medium">{{ auditResult.total }}</span>
					个商品
				</p>
				<p>
					<span class="font-h4-medium yx-color-success">{{ auditResult.success }}</span>
					个操作成功，
					<span class="font-h4-medium yx-color-danger">{{ auditResult.fail }}</span>
					个操作失败
				</p>
			</div>
		</div>
		<span slot="footer">
			<el-button type="primary" @click="resultDialogVisble = false">我知道了</el-button>
		</span>
	</el-dialog>
</template>
<script>
export default {
	props: {
		auditResult: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			resultDialogVisble: false,
		};
	},
	methods: {
		show() {
			this.resultDialogVisble = true;
		},
	},
};
</script>
<style lang="less" scoped>
.gap-16 {
	gap: 16px;
}
.import-content {
	.title {
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #323233;
	}
	.desc {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #969799;
		line-height: 18px;
	}
	.link {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #ee0a24;
		line-height: 18px;
	}
}
</style>
